// Reopen only when Shopify renders a confirmed success or validation error.
// Native form submission keeps Shopify's spam protection and challenge flow.
if (!customElements.get('contact-form-feedback')) {
  // The theme uses different animation targets on mobile and desktop.
  // Clear the previous breakpoint's animation styles before reopening.
  document.addEventListener('dialog:before-show', (event) => {
    const modal = event.target;
    if (!modal.matches('.contact-form-modal')) return;
    modal.style.removeProperty('opacity');
    modal.shadowRoot?.querySelector('[part="content"]')?.style.removeProperty('transform');
    modal.shadowRoot?.querySelector('[part="overlay"]')?.style.removeProperty('opacity');
  }, true);

  customElements.define('contact-form-feedback', class extends HTMLElement {
    async connectedCallback() {
      await customElements.whenDefined('x-modal');
      requestAnimationFrame(async () => {
        if (!this.isConnected || this.hasOpened) return;
        const modal = this.closest('x-modal');
        if (!modal) return;
        this.hasOpened = true;
        modal.setAttribute('initial-focus', 'contact-form-feedback');
        await modal.show(false);
        if (this.isConnected && modal.open) this.focus({ preventScroll: true });
      });
    }
  });
}
